import { BASE_URL } from 'constants/api';

const DOCS_SPREADSHEETS_COMMON_URL = `https://docs.google.com/spreadsheets/d/`;

export const CSV_LINK_FOR_UPDATE_PAYMENTS = `${DOCS_SPREADSHEETS_COMMON_URL}1JSgclSApV2itRjhzt4WDbPs2jcV35FSYj-8sE5mXptk/edit?usp=sharing`;
export const CSV_LINK_FOR_UPLOAD_PAYMENTS = `${DOCS_SPREADSHEETS_COMMON_URL}1VSJJuGJzhFwe_DRhgu10bTSv2TCfct-BbyXeaRxBf_0/edit?usp=sharing`;

export const STUDENT_PAYMENTS_URL = `${BASE_URL}/student-payment-link-batch`;

export const STUDENT_PAYMENTS_ACTIONS = {
  MODIFY_EXISTING_PLANS: 'Modify Existing Plans',
  UPLOAD_PLANS: 'Upload Plans',
};

export const UPLOAD_FILE = {
  UPLOAD_MODIFIED_PAYMENTS_HERE: 'Upload updated payment links here',
  UPLOAD_NEW_PAYMENTS_HERE: 'Upload new payment links here',
};

export const STUDENT_PAYMENTS_HEADINGS = {
  MODIFY_PAYMENTS: 'Modify Student Payment Links',
  UPLOAD_PAYMENTS: 'Upload Student Payment Links',
};

export const ERROR_MSG =
  'Data in the csv has been uploaded. please check the downloaded csv for migration status';
